import { render, staticRenderFns } from "./FormSwitch.vue?vue&type=template&id=439890c4&scoped=true&"
import script from "./FormSwitch.vue?vue&type=script&lang=ts&"
export * from "./FormSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439890c4",
  null
  
)

export default component.exports